/**
 * Enum of status for testing, training and medical clearance.
 */
export enum Status {
  Compliant = 'compliant',
  DueSoonScheduled = 'dueSoonScheduled',
  DueSoonNotScheduled = 'dueSoonNotScheduled',
  OverdueScheduled = 'overdueScheduled',
  OverdueNotScheduled = 'overdueNotScheduled',
  NoRecord = 'noRecord'
}
